import propOr from 'ramda/src/propOr';
import { FETCH_SHOP_LOAN, CREATE_SHOP_LOAN, UPDATE_SHOP_LOAN } from '../constants';

const loan = (state = {}, action) => {
  switch (action.type) {
    case FETCH_SHOP_LOAN:
    case CREATE_SHOP_LOAN:
    case UPDATE_SHOP_LOAN:
      return action.payload;
    default:
      return state;
  }
};

export default loan;

export const getLoan = state => state.admin.shops.loan;
export const getLoanAmountOwed = state => propOr(0, 'loanAmountOwed', getLoan(state));
export const getLoanDetailHistory = state => propOr([], 'loanDetailHistory', getLoan(state));
